
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

export const useLanguage = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    localStorage.setItem('preferred-language', language);
    
    // Set document direction for RTL languages
    const isRTL = ['he', 'ar'].includes(language);
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  };

  // Set initial direction based on current language
  useEffect(() => {
    const isRTL = ['he', 'ar'].includes(i18n.language);
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return {
    currentLanguage: i18n.language,
    changeLanguage,
    t,
    isRTL: ['he', 'ar'].includes(i18n.language)
  };
};
